/* 📦 LIBS */
import Lottie from "lottie-react";

/* 📁 ASSETS*/
import JsonLoading from "../../Assets/json/loader.json";

/* 🎨 STYLES */
import { Container } from "./styles";

const CustomLoading = (props) => {
    return(
        <Container $width={'100%'} $height={'100%'}>
            <Lottie animationData={JsonLoading} loop={true} assetsPath="/assets/json/images/" style={{ width: props.width, height: props.height }} />
        </Container>
    )
}

export default CustomLoading;